import React from 'react';
import styled from '@emotion/styled';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 15px;
  width: ${(props) => props.widthPercentage};
`;

const Label = styled.label`
  font-size: 0.8rem;
  margin-bottom: 5px;
  text-align: left;
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const CurrencySymbol = styled.span`
  position: absolute;
  left:13px;
  top: 45%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #333;
`;

const Input = styled.input`
  padding: 8px 8px 8px 30px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  background-color: ${(props) => (props.missing ? '#ffdddd' : 'white')};
  font-size: 16px;
  box-sizing: border-box;
`;

const ErrorMessage = styled.span`
  position: absolute;
  bottom: -20px;
  left: 0;
  color: #880808;
  font-size: 12px;
`;

const TextInputWithLabel = ({
  label,
  optional = false,
  width = '100%',
  type = 'text',
  value,
  onChange,
  required = false,
  missing = false,
  invalidData,
  disabled = false,
  currency,
  ...inputProps
}) => {
  return (
    <InputContainer widthPercentage={width}>
      <Label>
        {label}
        {required && <span style={{ color: '#880808' }}> *</span>}
        {optional ? <span style={{ color: '#727272' }}> (optional)</span> : null}
      </Label>
      <InputWrapper>
        {currency && <CurrencySymbol>{currency}</CurrencySymbol>}
        <Input
          type={type}
          value={value}
          onChange={onChange}
          missing={missing}
          disabled={disabled}
          style={{ paddingLeft: currency ? '30px' : '8px' }}
          {...inputProps}
        />
        {invalidData && <ErrorMessage>{invalidData}</ErrorMessage>}
      </InputWrapper>
    </InputContainer>
  );
};

export default TextInputWithLabel;